import { Component, OnInit, Input, ViewChild, Output, EventEmitter, ElementRef } from '@angular/core';
import { NgxDropzoneComponent } from 'ngx-dropzone';
import { UploadedFile, ReadFileFormat } from './uploadedFile.model';
import { FileTypeUtils } from '../../services/file-type-utils';

@Component({
  selector: 'topo-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss'],
  standalone: false
})
export class FileUploadComponent implements OnInit {
  @Output() fileUploaded = new EventEmitter<UploadedFile>();
  @Input() label: string;
  @Input() fileFormat = this.utils.allFileFormatsForUpload;
  @Input() isLarge = false;
  @Input() readFileFormat: ReadFileFormat = ReadFileFormat.None;
  @Input() height: number;
  @ViewChild('drop') drop: NgxDropzoneComponent;

  constructor(private utils: FileTypeUtils) {}

  ngOnInit(): void {}

  showFileSelector(): void {
    this.drop.showFileSelector();
  }

  disable(value: boolean): void {
    this.drop.disabled = value;
  }

  onFileChange(event: any): void {
    if (!(event.addedFiles.length > 0)) {
      return;
    }

    const fileReader = new FileReader();
    const fileIndex = event.addedFiles.length - 1;
    const file = event.addedFiles[fileIndex];

    fileReader.onloadend = e => {
      const data = fileReader.result;
      const fileName = file.name;

      const uploadedFile: UploadedFile = {
        data,
        fileName: file.name,
        file
      };

      this.fileUploaded.emit(uploadedFile);
    };

    switch (this.readFileFormat) {
      case ReadFileFormat.ArrayBuffer:
        fileReader.readAsArrayBuffer(file);
        break;

      case ReadFileFormat.BinaryString:
        fileReader.readAsBinaryString(file);
        break;

      case ReadFileFormat.DataUrl:
        fileReader.readAsDataURL(file);
        break;

      case ReadFileFormat.Text:
        fileReader.readAsText(file);
        break;
    }
  }
}
